export const getOrInsertGlobal = (namespace, initialValue) => {
  const key = `__early${namespace}Requests`;
  const global = window;
  if (!(key in global)) {
    global[key] = initialValue();
  }
  return global[key];
};